import { images } from "../../../Assets/assetsHelper";
import "./SchoolProfile.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import AddSchoolForm from "../../../Components/Organisms/Forms/AddSchoolForm/AddSchoolForm";
import { MoonLoader } from "react-spinners";
import { BaseURL } from "../../../Hooks/URL";
import ApartmentIcon from "@mui/icons-material/Apartment";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import { useNavigate } from "react-router";
import Groups2Icon from "@mui/icons-material/Groups2";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import SchoolIcon from "@mui/icons-material/School";
import ClassIcon from "@mui/icons-material/Class";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { BarChart } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";
import CourseCard from "../../../Components/Molecules/Cards/CourseCard/CourseCard";
import DoneIcon from "@mui/icons-material/Done";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import BarChartIcon from "@mui/icons-material/BarChart";
import PieChartIcon from "@mui/icons-material/PieChart";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import { Bar, Line, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

function SchoolProfile({
  Open,
  setOpen,
  school,
  setSchool,
  url,
  setGo,
  loading,
  statistics,
  role,
  classes,
  classesLoading,
  setGoSave,
  goSave,
  addLoading,
  setGoActivate,
  goActivate,
  addActivateLoading,
}) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="mainContainer">
      {school && (
        <>
          {/* Action Buttons */}
          <div className="profileActions">
            {role == "admin" && (
              <button
                className="actionButton primary"
                onClick={() => setGoActivate(true)}
                disabled={addActivateLoading}
              >
                {addActivateLoading ? (
                  <MoonLoader color="white" size={8} />
                ) : null}
                {school?.active ? "Deactivate School" : "Activate School"}
              </button>
            )}

            {!school?.active && (
              <button
                className="actionButton primary"
                onClick={() => setGoSave(true)}
                disabled={addLoading}
              >
                {addLoading ? <MoonLoader color="white" size={8} /> : null}
                Resend Verification
              </button>
            )}

            <button
              className="actionButton primary"
              onClick={() => navigate(`/schools/add/${school?.id}`)}
            >
              Edit School
            </button>

            <DeleteForm
              setGo={setGo}
              title={"Are you sure to delete this school ?"}
            />
          </div>

          {/* About Section */}
          <div className="contentSection">
            <div className="aboutSchoolHeader">
              <div className="schoolLogoSection">
                {school?.logoFilePath ? (
                  <img
                    src={`${BaseURL}/${school?.logoFilePath}`}
                    alt="School Logo"
                    className="schoolLogoLarge"
                  />
                ) : (
                  <div className="schoolLogoPlaceholderLarge">
                    <ApartmentIcon style={{ fontSize: "48px" }} />
                  </div>
                )}
              </div>

              <div className="schoolBasicInfo">
                <h1 className="schoolName">{school.name}</h1>
                {school?.website && (
                  <a
                    href={school.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="schoolWebsite"
                  >
                    {school.website}
                  </a>
                )}

                <div className="schoolSocialLinks">
                  {school?.facebook && (
                    <a
                      href={school.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="socialLink facebook"
                      title="Facebook"
                    >
                      <FacebookIcon />
                    </a>
                  )}
                  {school?.instagram && (
                    <a
                      href={school.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="socialLink instagram"
                      title="Instagram"
                    >
                      <InstagramIcon />
                    </a>
                  )}
                  {school?.whatsappLink && (
                    <a
                      href={school.whatsappLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="socialLink whatsapp"
                      title="WhatsApp"
                    >
                      <WhatsAppIcon />
                    </a>
                  )}
                </div>
              </div>
            </div>

            <h2 className="sectionTitle">School Details</h2>
            <div className="infoGrid">
              <div className="infoItemLarge">
                <div className="infoLabel">Description</div>
                <div className="infoValue">
                  {school?.about || "No description available"}
                </div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Email</div>
                <div className="infoValue">{school?.email}</div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Phone Number</div>
                <div className="infoValue">{school?.phone}</div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Whatsapp Number</div>
                <div className="infoValue">{`+${school?.whatsappLink
                  ?.split("=")
                  ?.at(1)}`}</div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Address</div>
                <div className="infoValue">
                  {school?.country?.name} / {school?.city?.name} /{" "}
                  {school?.street}
                </div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Status</div>
                <div
                  className={`statusIndicator ${
                    school?.active ? "active" : "inactive"
                  }`}
                >
                  {school?.active ? <DoneIcon /> : <CloseIcon />}
                  {school?.active ? "Activated" : "Not Activated"}
                </div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Joining Date</div>
                <div className="infoValue">
                  {new Date(school?.joinDate).toLocaleString()}
                </div>
              </div>
            </div>
          </div>

          {/* Statistics Grid */}
          <div className="statsGrid">
            <div className="statCard">
              <div className="statIcon primary">
                <SchoolIcon />
              </div>
              <div className="statContent">
                <h4>Instructors</h4>
                <h2>{statistics?.counting?.totalTeachers || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon success">
                <Groups2Icon />
              </div>
              <div className="statContent">
                <h4>Students</h4>
                <h2>{statistics?.counting?.totalStudents || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon warning">
                <ClassIcon />
              </div>
              <div className="statContent">
                <h4>Classes</h4>
                <h2>{statistics?.counting?.totalClasses || 0}</h2>
              </div>
            </div>
          </div>

          {/* Charts Section */}
          <div className="chartsContainer">
            <div className="chartGrid">
              {/* Student Enrollment Chart */}
              <div className="chartCard large">
                <div className="chartHeader">
                  <div className="chartTitle">
                    <BarChartIcon className="chartIcon" />
                    <h3>Student Enrollment by Month</h3>
                  </div>
                </div>
                <div className="chartContent">
                  {statistics?.studentsEnrollmentOverYear?.length ? (
                    <Line
                      data={{
                        labels:
                          statistics?.studentsEnrollmentOverYear?.map(
                            (item) => item?.month
                          ) || [],
                        datasets: [
                          {
                            label: "Students Enrolled",
                            data:
                              statistics?.studentsEnrollmentOverYear?.map(
                                (item) => item?.enrollments
                              ) || [],
                            borderColor: "#012369",
                            backgroundColor: "rgba(1, 35, 105, 0.1)",
                            borderWidth: 5,
                            fill: true,
                            tension: 0.4,
                            pointBackgroundColor: "#012369",
                            pointBorderColor: "#ffffff",
                            pointBorderWidth: 2,
                            pointRadius: 6,
                            pointHoverRadius: 8,
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: true,
                            position: "top",
                            labels: {
                              usePointStyle: true,
                              padding: 20,
                              font: {
                                size: 12,
                                weight: "600",
                              },
                            },
                          },
                          tooltip: {
                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                            titleColor: "#333",
                            bodyColor: "#666",
                            borderColor: "#e0e0e0",
                            borderWidth: 1,
                            cornerRadius: 8,
                            displayColors: true,
                            titleFont: {
                              size: 14,
                              weight: "bold",
                            },
                            bodyFont: {
                              size: 13,
                            },
                          },
                        },
                        scales: {
                          x: {
                            grid: {
                              display: false,
                            },
                            ticks: {
                              color: "#666",
                              font: {
                                size: 11,
                              },
                            },
                          },
                          y: {
                            beginAtZero: true,
                            grid: {
                              color: "rgba(0, 0, 0, 0.05)",
                            },
                            ticks: {
                              color: "#666",
                              font: {
                                size: 11,
                              },
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <div className="emptyChart">
                      <BarChartIcon className="emptyIcon" />
                      <p>No enrollment data available</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Classes per Course Pie Chart */}
              <div className="chartCard small">
                <div className="chartHeader">
                  <div className="chartTitle">
                    <PieChartIcon className="chartIcon" />
                    <h3>Classes per Program</h3>
                  </div>
                </div>
                <div className="chartContent">
                  {statistics?.numberOfClassesPerCourse?.length ? (
                    <Doughnut
                      data={{
                        labels:
                          statistics?.numberOfClassesPerCourse
                            ?.slice(0, 5)
                            ?.map((item) => item?.courseTitle) || [],
                        datasets: [
                          {
                            data:
                              statistics?.numberOfClassesPerCourse
                                ?.slice(0, 5)
                                ?.map((item) => item?.totalClasses) || [],
                            backgroundColor: [
                              "#012369",
                              "#1976d2",
                              "#42a5f5",
                              "#90caf9",
                              "#bbdefb",
                            ],
                            borderColor: "#ffffff",
                            borderWidth: 2,
                            hoverBorderWidth: 3,
                            hoverOffset: 8,
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        cutout: "60%",
                        plugins: {
                          legend: {
                            display: true,
                            position: "bottom",
                            labels: {
                              usePointStyle: true,
                              padding: 15,
                              font: {
                                size: 11,
                                weight: "500",
                              },
                              boxWidth: 12,
                              boxHeight: 12,
                            },
                          },
                          tooltip: {
                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                            titleColor: "#333",
                            bodyColor: "#666",
                            borderColor: "#e0e0e0",
                            borderWidth: 1,
                            cornerRadius: 8,
                            displayColors: true,
                            titleFont: {
                              size: 14,
                              weight: "bold",
                            },
                            bodyFont: {
                              size: 13,
                            },
                            callbacks: {
                              label: function (context) {
                                return `${context.label}: ${context.parsed} classes`;
                              },
                            },
                          },
                        },
                        elements: {
                          arc: {
                            borderWidth: 0,
                          },
                        },
                      }}
                    />
                  ) : (
                    <div className="emptyChart">
                      <PieChartIcon className="emptyIcon" />
                      <p>No program data available</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Gender Distribution Chart */}
              <div className="chartCard medium">
                <div className="chartHeader">
                  <div className="chartTitle">
                    <PersonIcon className="chartIcon" />
                    <h3>Gender Distribution by Age</h3>
                  </div>
                </div>
                <div className="chartContent">
                  {statistics?.agesWithGender?.length ? (
                    <Bar
                      data={{
                        labels:
                          statistics?.agesWithGender?.map(
                            (item) => item?.age
                          ) || [],
                        datasets: [
                          {
                            label: "Male",
                            data:
                              statistics?.agesWithGender?.map(
                                (item) => item?.male
                              ) || [],
                            backgroundColor: "#1976d2",
                            borderColor: "#1565c0",
                            borderWidth: 1,
                            borderRadius: 4,
                            borderSkipped: false,
                          },
                          {
                            label: "Female",
                            data:
                              statistics?.agesWithGender?.map(
                                (item) => item?.female
                              ) || [],
                            backgroundColor: "#dc004e",
                            borderColor: "#c51162",
                            borderWidth: 1,
                            borderRadius: 4,
                            borderSkipped: false,
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: true,
                            position: "top",
                            labels: {
                              usePointStyle: true,
                              padding: 20,
                              font: {
                                size: 12,
                                weight: "600",
                              },
                            },
                          },
                          tooltip: {
                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                            titleColor: "#333",
                            bodyColor: "#666",
                            borderColor: "#e0e0e0",
                            borderWidth: 1,
                            cornerRadius: 8,
                            displayColors: true,
                            titleFont: {
                              size: 14,
                              weight: "bold",
                            },
                            bodyFont: {
                              size: 13,
                            },
                          },
                        },
                        scales: {
                          x: {
                            grid: {
                              display: false,
                            },
                            ticks: {
                              color: "#666",
                              font: {
                                size: 11,
                              },
                            },
                          },
                          y: {
                            beginAtZero: true,
                            grid: {
                              color: "rgba(0, 0, 0, 0.05)",
                            },
                            ticks: {
                              color: "#666",
                              font: {
                                size: 11,
                              },
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <div className="emptyChart">
                      <PersonIcon className="emptyIcon" />
                      <p>No gender data available</p>
                    </div>
                  )}
                </div>
              </div>

              {/* Average Grades Chart */}
              <div className="chartCard medium">
                <div className="chartHeader">
                  <div className="chartTitle">
                    <TrendingUpIcon className="chartIcon" />
                    <h3>Average Grades per Program</h3>
                  </div>
                </div>
                <div className="chartContent">
                  {statistics?.coursesWithAverageGrade?.length ? (
                    <Bar
                      data={{
                        labels:
                          statistics?.coursesWithAverageGrade?.map(
                            (item) => item?.courseTitle
                          ) || [],
                        datasets: [
                          {
                            label: "Average Grade",
                            data:
                              statistics?.coursesWithAverageGrade?.map(
                                (item) => item?.averageGrade
                              ) || [],
                            backgroundColor: "#012369",
                            borderColor: "#012369",
                            borderWidth: 2,
                            borderRadius: 6,
                            borderSkipped: false,
                            gradient: {
                              backgroundColor: {
                                type: "linear",
                                x0: 0,
                                y0: 0,
                                x1: 0,
                                y1: 1,
                                colorStops: [
                                  { offset: 0, color: "#012369" },
                                  { offset: 1, color: "#42a5f5" },
                                ],
                              },
                            },
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: true,
                            position: "top",
                            labels: {
                              usePointStyle: true,
                              padding: 20,
                              font: {
                                size: 12,
                                weight: "600",
                              },
                            },
                          },
                          tooltip: {
                            backgroundColor: "rgba(255, 255, 255, 0.95)",
                            titleColor: "#333",
                            bodyColor: "#666",
                            borderColor: "#e0e0e0",
                            borderWidth: 1,
                            cornerRadius: 8,
                            displayColors: true,
                            titleFont: {
                              size: 14,
                              weight: "bold",
                            },
                            bodyFont: {
                              size: 13,
                            },
                            callbacks: {
                              label: function (context) {
                                return `Average Grade: ${context.parsed.y}`;
                              },
                            },
                          },
                        },
                        scales: {
                          x: {
                            grid: {
                              display: false,
                            },
                            ticks: {
                              color: "#666",
                              font: {
                                size: 10,
                              },
                              maxRotation: 45,
                            },
                          },
                          y: {
                            beginAtZero: true,
                            max: 5,
                            grid: {
                              color: "rgba(0, 0, 0, 0.05)",
                            },
                            ticks: {
                              color: "#666",
                              font: {
                                size: 11,
                              },
                              callback: function (value) {
                                return value;
                              },
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <div className="emptyChart">
                      <TrendingUpIcon className="emptyIcon" />
                      <p>No grade data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Latest Classes Section */}
          <div className="contentSection">
            <div className="classesHeader">
              <h2 className="sectionTitle">Latest Classes</h2>
              <button
                className="actionButton primary"
                onClick={() => navigate("/classes")}
              >
                See All Classes
              </button>
            </div>
            {classesLoading ? (
              <div className="loadingContainer">
                <MoonLoader color="#012369" size={40} />
              </div>
            ) : classes?.length ? (
              <div className="classesGrid">
                {classes?.map((item) => (
                  <CourseCard
                    class_id={item?.id}
                    class_name={item?.className}
                    course={item?.course?.title}
                    teacher={item?.teacher?.name}
                    school={item?.school?.name}
                    terminated={item?.isTerminated}
                  />
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <h3>No Classes Created Yet</h3>
                <p>Classes will appear here once they are created</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default SchoolProfile;
